import {
  LegacyPortalPurchaseHistoryOrderStatus,
  LegacyPortalPurchaseHistoryProductType,
} from "@spwn-portal/grpc";
import { PAYMENT_TYPE } from "constants/paymentType";

import type { PaymentStatus, PayType } from "@spwn/types";

const PAYMENT_STATUS_BY_ORDER_STATUS: Record<
  LegacyPortalPurchaseHistoryOrderStatus,
  PaymentStatus | null
> = {
  [LegacyPortalPurchaseHistoryOrderStatus.CANCEL]: "CANCEL",
  [LegacyPortalPurchaseHistoryOrderStatus.PAYSUCCESS]: "PAYSUCCESS",
  [LegacyPortalPurchaseHistoryOrderStatus.RETURN]: "RETURN",
  [LegacyPortalPurchaseHistoryOrderStatus.UNPROCESS]: "UNPROCESS",
  [LegacyPortalPurchaseHistoryOrderStatus.UNSPECIFIED]: null,
};

/** 注文状態のenumを画面の決済状態へ。未指定・未知はnull（表示は「不明」） */
export const toPaymentStatus = (
  status: LegacyPortalPurchaseHistoryOrderStatus
): PaymentStatus | null => PAYMENT_STATUS_BY_ORDER_STATUS[status] ?? null;

const payTypeRecord: Record<string, PayType | undefined> = PAYMENT_TYPE;

/** 支払方法の生値を画面のPayTypeへ。PayTypeに無い値（Shopify等）はnull（表示は「不明」） */
export const toPayType = (
  payType: string | null | undefined
): PayType | null => {
  if (payType === null || payType === undefined) return null;
  return payTypeRecord[payType] ?? null;
};

type PurchaseHistoryProductType = "goods" | "ticket";

/** 商品種別のenumを文字列へ。未指定はグッズ扱い（Firestore直読み側と同じ既定） */
export const toProductType = (
  productType: LegacyPortalPurchaseHistoryProductType
): PurchaseHistoryProductType => {
  if (productType === LegacyPortalPurchaseHistoryProductType.TICKET) {
    return "ticket";
  }
  return "goods";
};
